import { getClasses } from '@/_utils/classnames';
import { HRMarkup } from '../HRMarkup/HRMarkup';
import styles from './HorizontalSeparator.module.css';
import type { FC } from 'react';
import type { SeparatorProps } from '../../../Separator/Separator.types';

const HorizontalSeparator: FC<SeparatorProps> = ({
  isLight,
  className,
  isInverted,
  isAccent,
}) => {
  const hrClassNames: string = getClasses(
    styles.horizontalSeparator,
    className,
    {
      [styles.horizontalSeparatorRegular]: !isLight,
      [styles.horizontalSeparatorLight]: isLight,
      [styles.horizontalSeparatorInverted]: isInverted,
      [styles.horizontalSeparatorAccent]: isAccent,
    },
  );

  return <HRMarkup className={hrClassNames} />;
};

export { HorizontalSeparator };
